<template>
  <div> 
    <main class="container-fluid">
      <div class="row heading">
        <div class='col-4 px-3 pt-3 d-none d-md-flex'></div>
        <div class='col-24 col-md-16 px-3 pt-3'>
          <h1 class="title pt-2 mb-0" v-text="$ml.get('repTitle')"></h1>
          <h1 class="title"><span v-text="$ml.get('repSubTitle')" class="pb-2"></span></h1>  
        </div>
      </div>
      <Report filter="pending"/>
    </main>
  </div>
</template>

<script>
import Report from "../../../components/report/report";

export default {
  components: {
    Report
  },
  data() {
    return {
      title: "Pending",
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {},
  },
};
</script>

<style scoped>
</style>